import { createSelector } from 'reselect';

const selectRazorpays = (state: any) => state.razorpays;

export const selectRazorpaysCurrentItem = createSelector([selectRazorpays], (razorpays) => razorpays.current);

export const selectRazorpaysListItems = createSelector([selectRazorpays], (razorpays) => razorpays.list);

export const selectRazorpaysItemById = (itemId: any) =>
    createSelector(selectRazorpaysListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectRazorpaysQueryItems = createSelector([selectRazorpays], (razorpays) => razorpays.query);

export const selectRazorpaysCreatedItem = createSelector([selectRazorpays], (razorpays) => razorpays.create);

export const selectRazorpaysUpdatedItem = createSelector([selectRazorpays], (razorpays) => razorpays.update);

export const selectRazorpaysReadItem = createSelector([selectRazorpays], (razorpays) => razorpays.read);

export const selectRazorpaysDeletedItem = createSelector([selectRazorpays], (razorpays) => razorpays.delete);

export const selectRazorpaysSearchedItems = createSelector([selectRazorpays], (razorpays) => razorpays.search);

export const selectRazorpaysItemsCount = createSelector([selectRazorpays], (razorpays) => razorpays.count);

export const selectRazorpaysItemsFilter = createSelector([selectRazorpays], (razorpays) => razorpays.filter);